import { render, staticRenderFns } from "./TreeRegistryList.vue?vue&type=template&id=40375d84&"
import script from "./TreeRegistryList.vue?vue&type=script&lang=ts&"
export * from "./TreeRegistryList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports